import React, { useState } from 'react'

import { Container } from './styles'

import { MdVisibility, MdVisibilityOff } from 'react-icons/md'

export function InputPasswordIcon({ hide, onChange }) {
  const [isHidden, setIsHidden] = useState(hide)

  function onClick() {
    setIsHidden((state) => {
      onChange(!state)
      return !state
    })
  }

  if (!hide) return null

  return (
    <Container onClick={onClick}>
      {isHidden ? <MdVisibility /> : <MdVisibilityOff />}
    </Container>
  )
}